import { isNil } from 'ramda';

import { validateRequired } from '../../../utils/validations';

import formMessages from '../../../containers/ShortLeaseApplication/messages';

import type { ContactInformation } from './types';

const warnContactArray = (contacts, type, intl) => {
  const warnings = [];

  if (!contacts || contacts.length === 0) {
    // Warn if no contacts at all
    warnings[0] =
      type === 'email'
        ? {
            emailAddress: intl.formatMessage(
              formMessages.requiredForCompletion,
            ),
          }
        : {
            phoneNumber: intl.formatMessage(formMessages.requiredForCompletion),
          };
    return warnings;
  }

  contacts.forEach((contact, index) => {
    const contactWarnings = {};
    const fieldName = type === 'email' ? 'emailAddress' : 'phoneNumber';

    // Warn for empty fields (all positions, not just primary)
    if (!contact[fieldName] || contact[fieldName].trim() === '') {
      contactWarnings[fieldName] = intl.formatMessage(
        formMessages.requiredForCompletion,
      );
    }

    if (Object.keys(contactWarnings).length > 0) {
      warnings[index] = contactWarnings;
    }
  });

  return warnings;
};

const warn = (values: ContactInformation, { intl, flags }: Object) => {
  const warnings = {};

  if (isNil(values)) {
    warnings.phoneNumber = intl.formatMessage(
      formMessages.requiredForCompletion,
    );
    return warnings;
  }

  // Check feature flag to determine which fields to warn about
  if (flags?.applicationAdditionalPhoneEmailAndTypes) {
    // Array-based warnings when feature flag is enabled
    if (values.emails) {
      const emailWarnings = warnContactArray(values.emails, 'email', intl);
      if (emailWarnings.length > 0) {
        warnings.emails = emailWarnings;
      }
    } else {
      // No emails array at all
      warnings.emails = [
        {
          emailAddress: intl.formatMessage(formMessages.requiredForCompletion),
        },
      ];
    }

    if (values.phones) {
      const phoneWarnings = warnContactArray(values.phones, 'phone', intl);
      if (phoneWarnings.length > 0) {
        warnings.phones = phoneWarnings;
      }
    } else {
      // No phones array at all
      warnings.phones = [
        { phoneNumber: intl.formatMessage(formMessages.requiredForCompletion) },
      ];
    }
  } else {
    // Legacy warnings when feature flag is disabled
    if (!validateRequired('emailAddress', values)) {
      warnings.emailAddress = intl.formatMessage(
        formMessages.requiredForCompletion,
      );
    }
    if (!validateRequired('phoneNumber', values)) {
      warnings.phoneNumber = intl.formatMessage(
        formMessages.requiredForCompletion,
      );
    }
  }

  return warnings;
};

export default warn;
